import {CreateJobApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import {Option} from "ts-option";
import SerialNumbersData from "./SerialNumbersData";

export default class JobData {
	constructor(public readonly principalContactId: string,
		public readonly description: Option<string>,
		public readonly extendedDescription: Option<string>,
		public readonly jobTypeId: string,
		public readonly siteId: Option<string>,
		public readonly serialNumbers: Option<SerialNumbersData>,
		public readonly merchantId: Option<string>,
		public readonly partsOnly: boolean,
		public readonly allowBom: boolean,
		public readonly merchantBranchLocationId: Option<string>,
		public readonly invoicePath: Option<string>,
		public readonly warrantyRegistrationStatus: Option<string>
	) {}

	toJson(): CreateJobApiDto {
		const json: CreateJobApiDto = {
			contactId: this.principalContactId,
			description: this.description.orNull,
			extendedDescription: this.extendedDescription.orNull,
			jobTypeId: this.jobTypeId,
			siteId: this.siteId.orNull,
			serialNumbers: this.serialNumbers.map(sn => sn.toJson()).orNull,
			merchantId: this.merchantId.orNull,
			merchantBranchLocationId: this.merchantBranchLocationId.orNull,
			invoicePath: this.invoicePath.orNull,
			warrantyRegistrationStatus: this.warrantyRegistrationStatus.orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({
		principalContactId = this.principalContactId,
		description = this.description,
		extendedDescription = this.extendedDescription,
		jobTypeId = this.jobTypeId,
		siteId = this.siteId,
		serialNumbers = this.serialNumbers,
		merchantId = this.merchantId,
		partsOnly = this.partsOnly,
		merchantBranchLocationId = this.merchantBranchLocationId,
		invoicePath = this.invoicePath,
		warrantyRegistrationStatus = this.warrantyRegistrationStatus,
	}) {
		return new JobData(
			principalContactId,
			description,
			extendedDescription,
			jobTypeId,
			siteId,
			serialNumbers,
			merchantId,
			partsOnly,
			this.allowBom,
			merchantBranchLocationId,
			invoicePath,
			warrantyRegistrationStatus
		);
	}

}
